theme.NewsletterPopup = (function() {
  function Popup(e) {
    var popup = document.getElementById("newsletter-popup");

    var dontShowCheckbox = document.getElementById("dont-show-again");
    var hideDuration = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
    
    
    if (!popup) {
      console.error("Element with ID 'newsletter-popup' not found.");
      return;
    }

    // Function to show the popup
    function showPopup() {
      popup.style.display = "flex";
      popup.classList.add("show");
    }

    // Function to hide the popup
    function hidePopup() {
      popup.classList.remove("show");
      popup.classList.add("hide");
      setTimeout(function() {
        popup.classList.remove("hide");
        popup.style.display = "none";
      }, 500); // Match this duration with the fade-out animation duration
    }

    var closePopupButton = document.getElementById("close-popup");
    if (closePopupButton) {
      // Close the popup when the close button is clicked
      closePopupButton.addEventListener("click", hidePopup);
    } else {
      console.error("Element with ID 'close-popup' not found.");
    }


    // Close the popup when the close button is clicked
    document.getElementById("close-popup").addEventListener("click", function() {
      if (dontShowCheckbox.checked) {
        var now = new Date().getTime();
        localStorage.setItem("popupHiddenUntil", now + hideDuration);
      }
      hidePopup();
    });
    

    // Close the popup when clicking outside the content area
    window.addEventListener("click", function(event) {
      if (event.target == popup) {
        hidePopup();
      }
    });

    // Check if in Shopify design mode
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", function(event) {
        if (event.target.querySelector("#newsletter-popup")) {
          showPopup();
        }
      });

      document.addEventListener("shopify:section:select", function(event) {
        if (event.target.querySelector("#newsletter-popup")) {
          showPopup();
        }
      });
    } else {
    // Check if the popup should be hidden
      var hiddenUntil = localStorage.getItem("popupHiddenUntil");
      var now = new Date().getTime();
      if (!hiddenUntil || now > hiddenUntil) {
        // Show popup normally after 5 seconds
        setTimeout(showPopup, 5000);
      }
    }
  }
  return Popup;
})();